/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavRecordConfig = {
  firm_config_version_id: number;
  firm_config_effective_from: string;
  /**
   * False when the firm's open version has moved on from the one this row was evaluated under -- i.e. a save has not been applied to this day. Expected to be False on any historical date, where the older rules are correct by design; only the day in progress should treat it as actionable.
   */
  is_latest_firm_config: boolean;
  trading_calendar: string;
  /**
   * Who works this row's review under the rules it was evaluated under. Drives the review modal's controls and the completion rule: a fund-managed row needs neither a second checkbox nor a note. Historical, like every other field here -- a firm that has since switched modes does not restate its past days.
   */
  monitoring_mode: DailyNavRecordConfig.monitoring_mode;
  /**
   * The currency this row's levels were converted into.
   */
  reporting_currency: string;
  short_window_sessions: number;
  long_window_sessions: number;
  /**
   * The firm defaults in force for this row, keyed by threshold field.
   */
  firm_thresholds: Record<string, string | null>;
  company_config_version_id: number;
  /**
   * The Alexandria profile this row's market data came from, snapshotted onto the version. Null = not linked. No firm-level counterpart -- it is a per-company fact, not a deviation from a default.
   */
  alexandria_id: string | null;
  /**
   * Only the threshold fields this company explicitly overrides. Absent keys inherit the firm default; a present key is an override even when its value equals the firm's, since null vs 0 vs equal-to-firm are three different states in the model. Empty object = pure inheritance.
   */
  company_overrides: Record<string, string | null>;
};
export namespace DailyNavRecordConfig {
  /**
   * Who works this row's review under the rules it was evaluated under. Drives the review modal's controls and the completion rule: a fund-managed row needs neither a second checkbox nor a note. Historical, like every other field here -- a firm that has since switched modes does not restate its past days.
   */
  export enum monitoring_mode {
    SCALAR_MANAGED = 'scalar_managed',
    FUND_MANAGED = 'fund_managed',
  }
}

